import React, { Component } from 'react';
import { default as pt } from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';
import styles from './index.scss';

class CancelButtonWithModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleOpen = () => {
    if (!this.props.disabled) {
      this.setState(() => {
        return { open: true };
      });
    } else {
      this.props.handleAction();
    }
  };

  handleCancelAndClose = () => {
    this.props.handleCancelAction && this.props.handleCancelAction();
    this.setState(() => {
      return { open: false };
    });
  };

  handleConfirm = (e) => {
    this.props.handleAction(e);
    this.setState(() => {
      return { open: false };
    });
  };

  render() {
    return (
      <Modal
        className={this.props.modalTestClasses}
        closeIcon={<span className={styles['close']}>X</span>}
        onClose={this.handleCancelAndClose}
        onOpen={() => {
          this.handleOpen();
        }}
        open={this.props.openModal || this.state.open}
        trigger={this.props.children}
      >
        <Modal.Header
          className={`${this.props.headerTestClasses} ${styles['modal-header']}`}
          content={this.props.headerCopy}
        />
        <Modal.Content
          className={`${this.props.modalContentTestClasses} ${styles['modal-content']}`}
        >
          <div>{this.props.contentCopy}</div>
        </Modal.Content>
        {!this.props.hideActions && (
          <Modal.Actions className={styles['modal-actions']}>
            <Button
              className={this.props.confirmTestClasses}
              color="grey"
              content={this.props.confirmButtonLabel}
              onClick={(e) => this.handleConfirm(e)}
              primary
              size={
                this.props.modalButtonSize
                  ? this.props.modalButtonSize
                  : 'medium'
              }
              disabled={
                this.props.confirmButtonDisabled
                  ? this.props.confirmButtonDisabled()
                  : false
              }
            />
            <Button
              basic
              className={this.props.cancelTestClasses}
              content={this.props.cancelButtonLabel}
              onClick={this.handleCancelAndClose}
              primary
              size={
                this.props.modalButtonSize
                  ? this.props.modalButtonSize
                  : 'medium'
              }
            />
          </Modal.Actions>
        )}
      </Modal>
    );
  }
}

CancelButtonWithModal.propTypes = {
  cancelButtonLabel: pt.string.isRequired,
  cancelTestClasses: pt.string.isRequired,
  confirmButtonLabel: pt.string.isRequired,
  confirmButtonDisabled: pt.func,
  confirmTestClasses: pt.string.isRequired,
  contentCopy: pt.string.isRequired,
  disabled: pt.bool,
  handleAction: pt.func.isRequired,
  handleCancelAction: pt.func,
  headerCopy: pt.string.isRequired,
  headerTestClasses: pt.string.isRequired,
  modalButtonSize: pt.string,
  modalContentTestClasses: pt.string.isRequired,
  modalTestClasses: pt.string.isRequired,
  openModal: pt.bool,
  hideActions: pt.bool,
};

export default CancelButtonWithModal;



// WEBPACK FOOTER //
// ./src/common/components/ConfirmCancelModal/ConfirmCancelModal.js